import { atom, useAtom, useAtomValue } from 'jotai';
import { ICompanyDataModel } from '../../../data-models/company.data-model';
import { IListItemDataModel } from '../../../data-models/list-item.data-model';
import { ListAuditDetails } from './ListAuditDetails';
import { ListItemDeleteModal } from './ListItemDeleteModal';
import { MoveListItemModal } from './MoveListItem';
import { moveListItemFormStateAtom, useResetMoveListItemFormState } from './MoveListItemState';

export const showListItemAuditDetailsAtom = atom<boolean>(false);
export const showListItemDeleteModalAtom = atom<boolean>(false);

interface IListItemModalsProps {
  item: IListItemDataModel;
  company: ICompanyDataModel;
}
export function ListItemModals({ item, company }: IListItemModalsProps) {
  const [showAuditDetails, setShowAuditDetails] = useAtom(showListItemAuditDetailsAtom);
  const [showDeleteModal, setShowDeleteModal] = useAtom(showListItemDeleteModalAtom);
  const moveListItemFormState = useAtomValue(moveListItemFormStateAtom);
  const resetMoveListItemFormState = useResetMoveListItemFormState();

  if (moveListItemFormState.show) {
    return (
      <MoveListItemModal
        sourceList={moveListItemFormState.sourceList}
        company={moveListItemFormState.company}
        onClose={resetMoveListItemFormState}
      />
    );
  } else if (showDeleteModal) {
    return <ListItemDeleteModal item={item} company={company} onClose={() => setShowDeleteModal(false)} />;
  } else if (showAuditDetails) {
    return <ListAuditDetails item={item} company={company} onClose={() => setShowAuditDetails(false)} />;
  }

  return null;
}
